<template>
  <li class="weath">
    <x-angleIcon></x-angleIcon>
    <div class="now">
      <img class="now-icon" :src="nowWeather.icon" alt="">
      <p><span>{{nowWeather.temp}}</span> ℃</p>
    </div>
    <div class="date-box">
      <span class="time">{{time}}</span>
      <p class="week">{{dateDetail.week}}</p>
      <p class="date">{{dateDetail.dateTxt}}</p>
    </div>
    <div class="forecast">
      <ul>
        <li class="item" v-for="(item, index) of forecast" :key="index">
          <img :src="item.icon" alt="">
          <div class="value">
            <p>{{item.tmpTxt}}</p>
            <span>{{item.dayTxt}}</span>
          </div>
        </li>
      </ul>
    </div>
  </li>

</template>

<script>
import { mapState } from 'vuex';
import { weatherApi } from '@/utils/mixins/weather';

export default {
  name: 'weather',
  mixins: [weatherApi],
  data () {
    return {
      isGetData: true,
      isFirst: true,
      forecastInterv: 0,
      interval: 0,
      weatherKey: 'b98fd0a207ae44c0addb3fa8ff7ef3de', // 公司 key
      weekArr: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    };
  },
  computed: {
    ...mapState(['dateDetail', 'forecast', 'nowWeather', 'time'])
  },
  created () {
    this.getLocation();

    this.realTime();
    this.realTimeInterval();
  },
  methods: {
    /* 3-10天预报 每天更新3次, 分别在8, 11, 18点左右更新 */
    forecastUpdate () {
      this.forecastInterv = (60 - new Date().getMinutes()) * 1000 * 60;
      if (this.isGetData === false) {
        this.forecastInterv = 10 * 1000 * 60;
      }
      let timeArr = [
        {hour: 7, minute: 50},
        {hour: 11, minute: 54},
        {hour: 12, minute: 50}
      ];
      for (let i = 0, len = timeArr.length; i < len; i++) {
        this.changeIsGet(timeArr[i]);
      }
      let forecast = setTimeout(() => {
        this.getForecastData();
        clearTimeout(forecast);
        this.forecastUpdate();
      }, this.forecastInterv);
    },
    changeIsGet (item) {
      let date = new Date();
      let hour = date.getHours();
      let minute = date.getMinutes();
      if (hour === item.hour && minute < item.minute) { // 7点50到8点10，10点50到11点10，17点50到18点10
        this.forecastInterv = (item.minute - minute) * 1000 * 60;
      } else if (hour === item.hour + 1 && minute < 10) {
        this.forecastInterv = (10 - minute) * 1000 * 60;
      }
    },
    /* 实况天气 每小时更新多次 */
    nowUpdate () {
      let nowInterval = setTimeout(() => {
        this.getNowWeather();
        clearTimeout(nowInterval);
        this.nowUpdate();
      }, 1000 * 60 * 20);
    },
    /* 实时时间定时器 */
    realTimeInterval () {
      if (this.isFirst) {
        this.interval = (60 - new Date().getSeconds()) * 1000;
      }
      let realTime = setTimeout(() => {
        this.realTime();
        this.isFirst = false;
        this.interval = 1000 * 60;
        clearTimeout(realTime);
        this.realTimeInterval();
      }, this.interval);
    },
    /* 获取实时时间 */
    realTime () {
      let date = new Date();
      let hour = date.getHours();
      hour = hour < 10 ? `0${hour}` : hour;
      let minute = date.getMinutes();
      minute = minute < 10 ? `0${minute}` : minute;
      this.$store.commit('setTime', `${hour}:${minute}`);
    }
  }
};

</script>

<style scoped>

</style>
